// source: type/price.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.type.Price', null, global);
goog.exportSymbol('proto.type.Price.PriceCase', null, global);
goog.exportSymbol('proto.type.TaxExcludedPrice', null, global);
goog.exportSymbol('proto.type.TaxExemptPrice', null, global);
goog.exportSymbol('proto.type.TaxIncludedPrice', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.Price = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.type.Price.oneofGroups_);
};
goog.inherits(proto.type.Price, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.Price.displayName = 'proto.type.Price';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.TaxExcludedPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.TaxExcludedPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.TaxExcludedPrice.displayName = 'proto.type.TaxExcludedPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.TaxIncludedPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.TaxIncludedPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.TaxIncludedPrice.displayName = 'proto.type.TaxIncludedPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.TaxExemptPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.TaxExemptPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.TaxExemptPrice.displayName = 'proto.type.TaxExemptPrice';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.type.Price.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.type.Price.PriceCase = {
  PRICE_NOT_SET: 0,
  TAX_EXCLUDED_PRICE: 1,
  TAX_INCLUDED_PRICE: 2,
  TAX_EXEMPT_PRICE: 3
};

/**
 * @return {proto.type.Price.PriceCase}
 */
proto.type.Price.prototype.getPriceCase = function() {
  return /** @type {proto.type.Price.PriceCase} */(jspb.Message.computeOneofCase(this, proto.type.Price.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.Price.prototype.toObject = function(opt_includeInstance) {
  return proto.type.Price.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.Price} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.Price.toObject = function(includeInstance, msg) {
  var f, obj = {
    taxExcludedPrice: (f = msg.getTaxExcludedPrice()) && proto.type.TaxExcludedPrice.toObject(includeInstance, f),
    taxIncludedPrice: (f = msg.getTaxIncludedPrice()) && proto.type.TaxIncludedPrice.toObject(includeInstance, f),
    taxExemptPrice: (f = msg.getTaxExemptPrice()) && proto.type.TaxExemptPrice.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of Price as accepted by the `fromObject` method.
 * @record
 */
proto.type.Price.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.taxExcludedPrice;

  /** @type {?|undefined} */
  this.taxIncludedPrice;

  /** @type {?|undefined} */
  this.taxExemptPrice;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.Price.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.Price}
 */
proto.type.Price.fromObject = function(obj) {
  var msg = new proto.type.Price();
  obj.taxExcludedPrice && jspb.Message.setWrapperField(
      msg, 1, proto.type.TaxExcludedPrice.fromObject(obj.taxExcludedPrice));
  obj.taxIncludedPrice && jspb.Message.setWrapperField(
      msg, 2, proto.type.TaxIncludedPrice.fromObject(obj.taxIncludedPrice));
  obj.taxExemptPrice && jspb.Message.setWrapperField(
      msg, 3, proto.type.TaxExemptPrice.fromObject(obj.taxExemptPrice));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.Price}
 */
proto.type.Price.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.Price;
  return proto.type.Price.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.Price} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.Price}
 */
proto.type.Price.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.type.TaxExcludedPrice;
      reader.readMessage(value,proto.type.TaxExcludedPrice.deserializeBinaryFromReader);
      msg.setTaxExcludedPrice(value);
      break;
    case 2:
      var value = new proto.type.TaxIncludedPrice;
      reader.readMessage(value,proto.type.TaxIncludedPrice.deserializeBinaryFromReader);
      msg.setTaxIncludedPrice(value);
      break;
    case 3:
      var value = new proto.type.TaxExemptPrice;
      reader.readMessage(value,proto.type.TaxExemptPrice.deserializeBinaryFromReader);
      msg.setTaxExemptPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.Price.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.Price.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.Price} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.Price.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaxExcludedPrice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.type.TaxExcludedPrice.serializeBinaryToWriter
    );
  }
  f = message.getTaxIncludedPrice();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.type.TaxIncludedPrice.serializeBinaryToWriter
    );
  }
  f = message.getTaxExemptPrice();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.type.TaxExemptPrice.serializeBinaryToWriter
    );
  }
};


/**
 * optional TaxExcludedPrice tax_excluded_price = 1;
 * @return {?proto.type.TaxExcludedPrice}
 */
proto.type.Price.prototype.getTaxExcludedPrice = function() {
  return /** @type{?proto.type.TaxExcludedPrice} */ (
    jspb.Message.getWrapperField(this, proto.type.TaxExcludedPrice, 1));
};


/**
 * @param {?proto.type.TaxExcludedPrice|undefined} value
 * @return {!proto.type.Price} returns this
*/
proto.type.Price.prototype.setTaxExcludedPrice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.type.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.Price} returns this
 */
proto.type.Price.prototype.clearTaxExcludedPrice = function() {
  return this.setTaxExcludedPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.Price.prototype.hasTaxExcludedPrice = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TaxIncludedPrice tax_included_price = 2;
 * @return {?proto.type.TaxIncludedPrice}
 */
proto.type.Price.prototype.getTaxIncludedPrice = function() {
  return /** @type{?proto.type.TaxIncludedPrice} */ (
    jspb.Message.getWrapperField(this, proto.type.TaxIncludedPrice, 2));
};


/**
 * @param {?proto.type.TaxIncludedPrice|undefined} value
 * @return {!proto.type.Price} returns this
*/
proto.type.Price.prototype.setTaxIncludedPrice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.type.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.Price} returns this
 */
proto.type.Price.prototype.clearTaxIncludedPrice = function() {
  return this.setTaxIncludedPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.Price.prototype.hasTaxIncludedPrice = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TaxExemptPrice tax_exempt_price = 3;
 * @return {?proto.type.TaxExemptPrice}
 */
proto.type.Price.prototype.getTaxExemptPrice = function() {
  return /** @type{?proto.type.TaxExemptPrice} */ (
    jspb.Message.getWrapperField(this, proto.type.TaxExemptPrice, 3));
};


/**
 * @param {?proto.type.TaxExemptPrice|undefined} value
 * @return {!proto.type.Price} returns this
*/
proto.type.Price.prototype.setTaxExemptPrice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.type.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.Price} returns this
 */
proto.type.Price.prototype.clearTaxExemptPrice = function() {
  return this.setTaxExemptPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.Price.prototype.hasTaxExemptPrice = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.TaxExcludedPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.type.TaxExcludedPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.TaxExcludedPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.TaxExcludedPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    taxRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of TaxExcludedPrice as accepted by the `fromObject` method.
 * @record
 */
proto.type.TaxExcludedPrice.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.amount;

  /** @type {?|undefined} */
  this.taxRate;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.TaxExcludedPrice.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.TaxExcludedPrice}
 */
proto.type.TaxExcludedPrice.fromObject = function(obj) {
  var msg = new proto.type.TaxExcludedPrice();
  obj.amount != null && jspb.Message.setField(msg, 1, obj.amount);
  obj.taxRate != null && jspb.Message.setField(msg, 2, obj.taxRate);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.TaxExcludedPrice}
 */
proto.type.TaxExcludedPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.TaxExcludedPrice;
  return proto.type.TaxExcludedPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.TaxExcludedPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.TaxExcludedPrice}
 */
proto.type.TaxExcludedPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTaxRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.TaxExcludedPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.TaxExcludedPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.TaxExcludedPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.TaxExcludedPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTaxRate();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional int32 amount = 1;
 * @return {number}
 */
proto.type.TaxExcludedPrice.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.TaxExcludedPrice} returns this
 */
proto.type.TaxExcludedPrice.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double tax_rate = 2;
 * @return {number}
 */
proto.type.TaxExcludedPrice.prototype.getTaxRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.type.TaxExcludedPrice} returns this
 */
proto.type.TaxExcludedPrice.prototype.setTaxRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.TaxIncludedPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.type.TaxIncludedPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.TaxIncludedPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.TaxIncludedPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    taxRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of TaxIncludedPrice as accepted by the `fromObject` method.
 * @record
 */
proto.type.TaxIncludedPrice.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.amount;

  /** @type {?|undefined} */
  this.taxRate;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.TaxIncludedPrice.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.TaxIncludedPrice}
 */
proto.type.TaxIncludedPrice.fromObject = function(obj) {
  var msg = new proto.type.TaxIncludedPrice();
  obj.amount != null && jspb.Message.setField(msg, 1, obj.amount);
  obj.taxRate != null && jspb.Message.setField(msg, 2, obj.taxRate);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.TaxIncludedPrice}
 */
proto.type.TaxIncludedPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.TaxIncludedPrice;
  return proto.type.TaxIncludedPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.TaxIncludedPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.TaxIncludedPrice}
 */
proto.type.TaxIncludedPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTaxRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.TaxIncludedPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.TaxIncludedPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.TaxIncludedPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.TaxIncludedPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTaxRate();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional int32 amount = 1;
 * @return {number}
 */
proto.type.TaxIncludedPrice.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.TaxIncludedPrice} returns this
 */
proto.type.TaxIncludedPrice.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double tax_rate = 2;
 * @return {number}
 */
proto.type.TaxIncludedPrice.prototype.getTaxRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.type.TaxIncludedPrice} returns this
 */
proto.type.TaxIncludedPrice.prototype.setTaxRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.TaxExemptPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.type.TaxExemptPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.TaxExemptPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.TaxExemptPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of TaxExemptPrice as accepted by the `fromObject` method.
 * @record
 */
proto.type.TaxExemptPrice.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.amount;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.TaxExemptPrice.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.TaxExemptPrice}
 */
proto.type.TaxExemptPrice.fromObject = function(obj) {
  var msg = new proto.type.TaxExemptPrice();
  obj.amount != null && jspb.Message.setField(msg, 1, obj.amount);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.TaxExemptPrice}
 */
proto.type.TaxExemptPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.TaxExemptPrice;
  return proto.type.TaxExemptPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.TaxExemptPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.TaxExemptPrice}
 */
proto.type.TaxExemptPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.TaxExemptPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.TaxExemptPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.TaxExemptPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.TaxExemptPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 amount = 1;
 * @return {number}
 */
proto.type.TaxExemptPrice.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.TaxExemptPrice} returns this
 */
proto.type.TaxExemptPrice.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


goog.object.extend(exports, proto.type);
